<template>
  <v-app :key="loginoutchange" :style="'pointer-events:'+(screenlocked ? 'none':'auto')">
    <!-- <v-system-bar
      color="black"
      v-if="!windowed"
      height=30
    > -->
    <v-system-bar
      :color="(proMode ? 'black' : 'teal lighten-4')"
      v-if="!$route.meta.popout && !$vuetify.breakpoint.xs && winHeight>600"
      height=30
    >
      <v-col cols="5">
        <v-menu 
          offset-y
          close-on-click
          close-on-content-click
        >
          <template v-slot:activator="{ on }">
            <v-btn
              :dark="proMode"
              text
              small
              :class="(proMode ? 'proColor ' : ' ')"
              v-on="on"
              style="text-transform: capitalize;padding-left:0;font-weight:thin;"
            >
              <pre>File</pre>
            </v-btn>
          </template>

          <v-list style="text-align:left;" dense :dark="proMode">
            <v-list-item
              v-for="(item, i) in fileItems" 
              :key="i"
              @click="router((item.route ? item.route : null),(item.param ? item.param : null))"
              :style="(item.divider ? 'padding:0;margin:0;min-height: 10px !important;' : '')" 
            >
              <v-divider style="padding:0;margin:0;min-height: 10px !important;" v-if="item.divider"></v-divider>
              <v-list-item-title v-else><pre>{{ item.title }}</pre></v-list-item-title>
            </v-list-item>
            <v-divider style="margin-bottom: 20px;"></v-divider>
            <v-list-item v-if="signedIn">
              <amplify-sign-out></amplify-sign-out>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu 
          offset-y
          close-on-click
          close-on-content-click
        >
          <template v-slot:activator="{ on }">
            <v-btn
              :dark="proMode"
              text
              small
              v-on="on"
              style="text-transform: capitalize;padding-left:0;font-weight:thin;"
              :class="(proMode ? 'proColor ' : ' ')"
            >
              <pre>User</pre>
            </v-btn>
          </template>

          <v-list style="text-align:left;" dense :dark="proMode">
            <v-list-item
              @click="switchTheme"
            >
              <v-list-item-title><pre><v-icon small :dark="proMode">mdi-theme-light-dark</v-icon> Switch Themes </pre></v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="switchBig"
            >
              <v-list-item-title><pre><v-icon small :dark="proMode">{{(bigMode ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all')}}</v-icon> {{(bigMode ? 'Shrink' : 'Expand')}} View </pre></v-list-item-title>
            </v-list-item>
            <v-divider style="margin-bottom: 10px;"></v-divider>
            <v-list-item
              @click="router('QA Review')"
            >
              <v-list-item-title v-if="userprof=='coder'"><pre>View My QA Results</pre></v-list-item-title>
              <v-list-item-title v-else><pre>View My Teams QA Results</pre></v-list-item-title>
            </v-list-item>
            <v-list-item
              disabled
              @click="downloadReport('qascore')"
            >
              <v-list-item-title v-if="userprof=='coder'"><pre>Download My QA Score</pre></v-list-item-title>
              <v-list-item-title v-else><pre>Download My Teams QA Score</pre></v-list-item-title>
            </v-list-item>
            <v-list-item
              disabled
              @click="downloadReport('qaencs')"
            >
              <v-list-item-title v-if="userprof=='coder'"><pre>Download My QA Details</pre></v-list-item-title>
              <v-list-item-title v-else><pre>Download My Teams QA Details</pre></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu 
          offset-y
          close-on-click
          close-on-content-click
        >
          <template v-slot:activator="{ on }">
            <v-btn
              :dark="proMode"
              text
              small
              v-on="on"
              style="text-transform: capitalize;padding-left:0;font-weight:thin;"
              :class="(proMode ? 'proColor ' : ' ')"
              :disabled="userprof=='coder'"
            >
              <pre>Data</pre>
            </v-btn>
          </template>

          <v-list style="text-align:left;" dense :dark="proMode">
            <v-list-item
              @click="downloadReport('deficients')"
              :disabled="!facRoute"
            >
              <v-list-item-title><pre>Deficients</pre></v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="downloadReport('deficientlogs')"
              :disabled="!facRoute"
            >
              <v-list-item-title><pre>Deficient Logs</pre></v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="downloadReport('exports')"
              :disabled="!facRoute"
            >
              <v-list-item-title><pre>Exports</pre></v-list-item-title>
            </v-list-item>
            <v-divider style="margin-bottom: 10px;"></v-divider>
            <v-list-item
              @click="downloadReport('qafacility')"
              disabled
            >
              <v-list-item-title><pre>Facility QA Report</pre></v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="facSettings.audit_only"
              @click="downloadReport('auditexternal')"
              :disabled="!facRoute"
            >
              <v-list-item-title><pre>Audit Data</pre></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu 
          offset-y
          close-on-click
          close-on-content-click
          dense
          :dark="proMode"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              :style="proMode ? 'color:white;' : 'color:black;'"
              small
              :dark="proMode"
              v-on="on"
              @click="userUpdate"
              class="ml-2"
            >
              <v-icon small :color="proMode ? 'white' : 'black'">mdi-account-group</v-icon> <pre>({{activeUsers.length}})</pre>
            </v-btn>
          </template>

          <v-list dense style="text-align:left;">
            <v-list-item
              v-for="(user, i) in activeUsers"
              :key="i"
              @click="showUser(user.userid)"
              style="text-transform: capitalize;font-weight:thin;"
              :class="(proMode ? 'proColor ' : ' ')"
            >
              <v-list-item class="pa-0 ma-0"><pre style="text-transform:none !important">{{ user.username }}: {{new Date(user.connectedAt).toLocaleString()}} - {{user.connectedTo.split("//")[1]}}</pre></v-list-item>
            </v-list-item>
            <!-- <v-list-item
              @click="signOut"
            >
              <v-list-item-title><pre>Test Signout</pre></v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="2">
        <pre v-if="timerEnabled" :class="(proMode ? 'proColor ' : ' ')"><strong>Logging out in {{timerCount}} minutes!</strong></pre>
        <pre v-else :class="(proMode ? 'proColor ' : ' ')"><strong>ExperiCoder</strong></pre>
      </v-col>
      <v-col cols="5" class="text-right">
        <v-icon style="height:20px" :color="proMode ? 'limegreen':'grey darken-3'">$vuetify.icons.IconOneColor</v-icon>
        <span @click="router('Home')" :class="(proMode ? 'proColor ' : ' ')" style="padding-right:5px;cursor:pointer;font-weight:bold;">AbacusOne </span>
      </v-col>
    </v-system-bar>
    <v-banner 
      two-line 
      style="margin-bottom:-73px; background-color:#EF6C00; z-index:9999" 
      :dark="proMode"
      v-if="banner"
      max-height="73px"
      elevation="2"
    >
      <v-avatar
        slot="icon"
        color="#EF6C00"
        size="40"
      >
        <v-icon
          icon="mdi-alert"
          color="white"
        >
          mdi-alert
        </v-icon>
      </v-avatar>

      Three line text string example with two actions. One to two lines is preferable. Three lines should be considered the maximum string length on desktop in order to keep messages short and actionable.

      <template v-slot:actions>
        <v-btn
          outlined
          color="white"
          @click="hideNotice"
        >
          HIDE
        </v-btn>
      </template>
    </v-banner>
    <v-subheader v-if="!$route.meta.popout && !$vuetify.breakpoint.xs && winHeight>600 && winHeight>600" :dark="proMode" :class="proMode ? 'proBground' : ''">
      <h2><pre>{{$store.getters.clientName}} - {{$store.getters.facilityName}}</pre></h2>
      <v-btn
        class="ma-2"
        outlined
        fab
        color="teal"
        x-small
        @click="facdocdialog = !facdocdialog"
        v-if="facDocs.length>0"
      >
        <v-icon>mdi-clipboard-plus</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <h2 v-if="facRoute"><pre>{{timeToExport}} until Export</pre></h2>
      <span v-else-if="this.$route.name != 'QA Review'"><v-btn
        depressed
        color="secondary"
        @click="router('QA Review')"
      >
        <pre v-if="userprof=='coder'">View My QA {{(userQAStatuses["NOT REVIEWED"] ? "(" + userQAStatuses["NOT REVIEWED"] + ")" : "")}}</pre>
        <pre v-else>View My Teams QA {{(userQAStatuses["NOT REVIEWED"] ? "(" + userQAStatuses["NOT REVIEWED"] + ")" : "")}}</pre>
      </v-btn>
      </span>
    </v-subheader>
    <v-progress-linear
      v-if="!$route.meta.popout && !$vuetify.breakpoint.xs && winHeight>600"
      :key="$store.getters.facility"
      :value="$store.getters.overallStatusCount.perComplete"
      height="25"
      :color="proMode ? '#2aad2a' : 'teal lighten-4'"
    >
      <pre>{{ $store.getters.overallStatusCount.complete }}/{{ $store.getters.overallStatusCount.total }}</pre>
    </v-progress-linear>
    <v-main>
      <router-view :key="$route.fullPath" :style="(!$route.meta.full ? 'height:' + vh : 'height:100vh')"/>
    </v-main>
    <v-dialog
        v-if="facdocdialog"
        v-model="facdocdialog"
        scrollable
        max-width="85%"
        style="min-height:90vh;"
        @click:outside="facdocdialog = !facdocdialog"
    >
        <v-card  :dark="proMode" style="height:90vh;padding:0">
            <v-card-title>
              Facility Documentation
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="padding:0px;">
                <v-row class="">
                    <v-col style="padding:0" cols="12">
                        <FacDocViewer :proMode="proMode" :facility="$store.getters.facility" :client="$store.getters.client" :docs="facDocs" :key="facDocs[0].dockey" height="85vh" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
        </v-card>
    </v-dialog>
    <!-- <v-bottom-navigation
      dark
      height="40"
    >
      <v-btn>
        <v-icon color="#2aad2a">mdi-table-row-plus-after</v-icon>
      </v-btn>

      <v-btn>
        <v-icon color="#2aad2a">mdi-table-row-plus-before</v-icon>
      </v-btn>
      <v-divider vertical></v-divider>
      <v-btn>
        <v-icon color="#2aad2a">mdi-table-column-plus-before</v-icon>
      </v-btn>

      <v-btn>
        <v-icon color="#2aad2a">mdi-table-column-plus-after</v-icon>
      </v-btn>
    </v-bottom-navigation> -->
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters } from "vuex";
import FacDocViewer from "./components/FacDocViewer.vue";

export default {
  name: 'App',
  components: {
    HelloWorld,
    FacDocViewer,
  },
  data: () => ({
    vh: "100%",
    signedIn:false,
    // items: [
    //   { title: 'Home', route: 'Home' }
    // ],
    activeUsers:[],
    route: "", //test
    windowed:null,
    banner:false,
    facdocdialog:false,
    facilityDocs:[],
    timerEnabled: false,
    timerCount:15,
    screenlocked:false,
    winHeight: window.innerHeight
  }),
  computed: {
        ...mapGetters(["userprof","username","userid","proMode","bigMode","facilitiesArr","facSettings","facDocs","fileItems","timeToExport","loginoutchange","userQAStatuses"]),
        facRoute(){
          return (this.$route.params && this.$route.params.facilityName ? this.$route.params.facilityName : null);
        },
        idleStr() {
          return this.isAppIdle ? 'ZZZ' : 'Hello'
        }
  },
  watch:{
    isAppIdle(){
        // console.log("IDLE? " + this.isAppIdle);
        if(this.isAppIdle){
          this.timerEnabled=true;
        }else{
          this.timerEnabled=false;
          this.timerCount=16;
        }
    },
    timerEnabled(value) {
        if (value) {
            this.timerCount--;
        }
    },
    timerCount: {
        handler(value) {
          if(this.timerEnabled){
            if (value > 0) {
                setTimeout(() => {
                    this.timerCount--;
                }, 60000);
            }else{
              // console.log("LOGGING YOU OUT!");
              this.signOut()
            }
          }
        },
        immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  async beforeCreate() {
    try {
      await this.$Amplify.Auth.currentAuthenticatedUser()
        .then((user) => (this.$store.dispatch("updateUser",user)))
        .catch((err) =>  console.log(err));
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", (info) => {
      // console.log("AUTH CHANGE: " + JSON.stringify(info));
      if(info!="forgotPassword"){
        this.$store.dispatch("addloginoutchange");
        window.location.reload(); 
        this.signedIn = info === "signedIn";
        // console.log("SIGNED: " + this.signedIn);
      }
    });

  if(this.signedIn){
      this.$store.dispatch('WSConnect',"wss://hkm37j7b07.execute-api.us-east-1.amazonaws.com/production?connectionType=status&jwt="+this.$store.getters.jwt);
      // this.$store.dispatch("updateEncounters");
      // this.$store.dispatch("updateEncountersTest");

      this.$store.dispatch("updateUserInfo").then(()=>{
        // if(this.userprof != "coder"){

        // }
        this.$store.dispatch("updateUserQAStatuses",{user:this.userid});
      });
      this.$store.dispatch("updateStatusesSSR");
      // this.$store.dispatch("updateEncountersInit").then(()=>{
      //   // console.log("ENCOUNTERS UPDATED INIT");
      //   //this.$store.dispatch("updateEncountersUpdatedInit");
      // });
        

      // console.log("ROUTE: " + this.$route.name);
      if(this.$route.name == "Auth"){
        // console.log(this.$route.query.redirect);
        if(this.$route.query.redirect){
          this.$router.push(this.$route.query.redirect);
        }else{
          this.$router.push({ name: "Home" });
        }
      }
    }
    //// console.log(JSON.stringify(this.$store.getters.jwt));
  },
  created(){
    // console.log("Created")
    document.addEventListener('visibilitychange',this.vizStateChange,false);
    //window.addEventListener('beforeunload', this.handler)
  },
  mounted(){
    this.winHeight = window.innerHeight;
    if(this.$vuetify.breakpoint.xs || this.winHeight<600){
      this.$router.push({ name: "Mobile" });
      this.screenlocked = true;
    }
    this.vh = (window.innerHeight - (25+48+30+40)) + "px";
    this.vh = (window.innerHeight - (25+48+30)) + "px";
    this.$root.vh = this.vh;
    this.$root.vhNum = (window.innerHeight - (25+48+30));
    this.getUsers();
    // this.items.push({divider:true,route:null});
    // for(let f=0; f<this.facilitiesArr.length; f++){
    //   this.items.push({
    //     title: this.facilitiesArr[f].facility_display_name, path: '/facility/' +  this.facilitiesArr[f].facility
    //   })
    // }
  },
  methods: {
    vizStateChange(){
      let vizState = document.visibilityState;
      // console.log("TAB: " + vizState);
      if(vizState=='hidden'){
        this.screenlocked = true;
        localStorage.setItem('idleTime', new Date().getTime());
      }else if(vizState=='visible'){
        let idleTime = localStorage.getItem('idleTime'),
            timeNow = new Date().getTime(),
            minDiff = ((timeNow-idleTime)/1000)/60;
        // console.log(minDiff);
        if(minDiff>15){
          // console.log("LOGGING YOU OUT!");
          this.signOut();
        }else{
          this.screenlocked = false;
        }
      }
    },
      async signOut(){
        // console.log("SIGNING OUT");
        await this.$Amplify.Auth.signOut()
          .then((data) =>  console.log(data))
          .catch((err) =>  console.log(err));
        location.reload();
      },
      switchTheme(){
        this.$store.dispatch("updateProMode",!this.proMode);
        this.changeFont();
        this.postData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/v2/users/byid/" + this.$store.getters.userid + "/update/proMode",{"value":this.proMode});
        //this.$vuetify.theme.dark = this.proMode;
      },
      switchBig(){
        this.$store.dispatch("updateBigMode",!this.bigMode);
        this.postData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/v2/users/byid/" + this.$store.getters.userid + "/update/bigMode",{"value":this.bigMode});
      },
      changeFont(){
        let pres = document.getElementsByTagName("PRE");
        for(let p=0; p<pres.length; p++){
          pres[p].style.fontFamily = (this.proMode ? 'monospace, monospace' : 'inherit');
        }
      },
      router(r,p) {
        if(r && p){
          // console.log("PATH")
          // this.$router.push({ path: p });
          let facInfo = this.$store.getters.facilities[p];
          this.openFacility(p,facInfo.client,facInfo.client_display_name,facInfo.facility_display_name);
          this.$router.push({ 
            name: r, 
            params:{
              facilityName: p
            }
          });
        }else if(r){
          this.$router.push({ name: r });
        } 
      },
      openFacility(fac,client,cdis,fdis){
        // console.log ("APP.VUE - SO LONG WE ARE GOING TO: " + fac);
        //this.$store.dispatch("updateFacDocs",{client:client,facility:fac});

        this.$store.dispatch("updateFac",fac);
        this.$store.dispatch("updateClient",client);

        this.$store.dispatch("updateFacClient",{
          facility:fdis,
          client:cdis
        })
      },
      hideNotice(){
        this.banner=false;
      },
      showUser(id){
        // console.log(id);
      },
      userUpdate(){
        this.getUsers();
      },
      async downloadReport(rep){
        //let file = await this.getFile("https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/coding/" + this.facRoute + "/" + rep + "?format=csv");
        //window.URL.createObjectURL(file);
        if(rep.includes("qa")){
          window.open("https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/user/" + this.userid + "/" + rep + "?format=csv");
        }else{
          window.open("https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/coding/" + this.facRoute + "/" + rep + "?format=csv");
        }
      },
      async getUsers(){
        let usersArr = await this.getData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/v2/users/active");
        usersArr.sort(function(a, b){
            if(a.connectedAt < b.connectedAt) { return -1; }
            if(a.connectedAt > b.connectedAt) { return 1; }
            return 0;
        })
        let usersRaw={},users=[];
        for(let u=0; u<usersArr.length; u++){
          let uukey = usersArr[u].userid + "_" + usersArr[u].connectedTo;
          if(usersRaw[uukey]){
            usersRaw[uukey].push(usersArr[u]);
          }else{
            usersRaw[uukey] = [usersArr[u]];
          }
        }
        let ukeys = Object.keys(usersRaw);
        for(let k=0; k<ukeys.length; k++){
          users.push(usersRaw[ukeys[k]].reduce(function(p, c) {
                      return (p.connectedAt > c.connectedAt ? p : c)
                    }))
        }
        this.activeUsers = users;
      },
      formatBytes:function(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        getFACDocs:function(client,facility){
          // console.log("GET FAC DOCS")
            this.getData(
                    "https://9ins5mn0lg.execute-api.us-east-1.amazonaws.com/v2/fac_docs/" + client + "/" + facility
                ).then((response) => {
                    // console.log("DOCS: " + response.length);
                    //// console.log(JSON.stringify(response[0]));
                    let filesOut = [];
                    for (let r=0; r<response.length; r++){
                        if(response[r].Size>0){
                            let d = new Date(response[r].LastModified);
                            filesOut.push({
                                filename:response[r].Key.split("/").pop(),
                                sizefix:this.formatBytes(response[r].Size),
                                uploaded:d.toUTCString()
                            });
                        }
                    }
                    this.facilityDocs = filesOut;
                });
        },
      async getData(url = "", data = {}) {
        const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
        
          // Default options are marked with *
          const response = await fetch(url, {
              method: "GET", // *GET, POST, PUT, DELETE, etc.
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                  "Content-Type": "application/json",
                  "Authorization": jwt
              },
              //redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          });
          return response.json(); // parses JSON response into native JavaScript objects
      },
      async getFile(url = "", data = {}) {
        const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();

            // Default options are marked with *
          const response = await fetch(url, {
              method: "GET", // *GET, POST, PUT, DELETE, etc.
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                  "Content-Type": "text/csv",
                  "Authorization": jwt
              },
              //redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          });
          return response; // parses JSON response into native JavaScript objects
      },
      async postData(url = "", data = {}) {
        const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();

              // Default options are marked with *
              const response = await fetch(url, {
              method: "POST", // *GET, POST, PUT, DELETE, etc.
              mode: "cors", // no-cors, *cors, same-origin
              cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                  "Content-Type": "application/json",
                  "Authorization": jwt
              },
              //redirect: 'follow', // manual, *follow, error
              //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              body: JSON.stringify(data), // body data type must match "Content-Type" header
              });
              return response.json(); // parses JSON response into native JavaScript objects
        },
    },
};
</script>
<style scoped>
  .v-banner__actions{
    margin-bottom:2px !important;
  }
</style>
<style>
  .proColor{
    color:limegreen;
  }
  .lightColor{
    color:rgba(0, 0, 0, 0.6);
  }
  .proBground{
    background-color:#212121 !important;
  }
  .lightBground{
    background-color: #4DB6AC !important;
  }
  .lighterBground{
    background-color: #b2dfdb !important;
  }
  .proFont{
    font-family: monospace, monospace;
  }
</style>
